import { onError, reportWebVitals } from '@praxis/component-logging'

// Standard errors will be automatically logged to STDOUT when thrown.
// The logging sidecar in TAP will process and send logs to the appropriate environment in Kibana.
// Learn more about TAP sidecars: https://tapdocs.prod.target.com/runtime/sidecars/#_platform_sidecars
window.onerror = onError

// If you want to start measuring performance in your app, enable the reportWebVitals()
// function below. Learn more: https://praxis.prod.target.com/components/logging#quick-start-metrics
reportWebVitals()

// Async boundary: dynamically importing the app defers consumption of
// non-eager shared modules (e.g. @design-systems/canvas-ui) until the Module
// Federation share scope is initialized. Without this, webpack throws
// "Shared module is not available for eager consumption".

// @ts-ignore -- webpack resolves the extensionless bootstrap module; TS's
// nodenext ESM resolution would otherwise demand a file extension here.
import('./App/bootstrap')

export {}
